<script src="../../../config/dev.env.js"></script>
<template>
  <div class="Sidebar">
    <div class="logBox">
      <router-link tag='a' to="/">
        <img src="/static/images/log.png">
      </router-link>
    </div>
    <div class="xiafangBox">
      <div class="userinfoBox yuanjiao">
        <div class="headPortrait" v-if="localUser !== null && localUser.headPortrait !== ''" :style="{backgroundImage:'url('+ossImgDomain+localUser.headPortrait+')'}"></div>
        <img v-if="localUser === null || localUser.headPortrait===''" src="/static/images/touxiang.jpg">
        <h6 v-if="localUser!==null">{{localUser.name}}</h6>
        <h6 @click="toLogin" class="cursor" v-else>未登录</h6>
        <p>雪帝 · 经销商</p>
        <span @click="showWeicode()" class="huanchongZhong"><i class="iconfont icon-user-group-fill"></i> 联系客服</span>
        <i class="iconfont icon-changpian1 bgIcon"></i>
      </div>
      <div class="pingBox" id="pingBox">
        <div class="menuBox dingBox" style="width: 100%;">
          <router-link v-for="(app,index) in navData" active-class='active' exact :key="index" tag='a' class="huanchongKuai yuanjiao" :to="app.to">
            <i class="iconfont" :class="app.class"></i>
            <span>{{app.title}}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import elementResizeDetectorMaker from 'element-resize-detector';
import { EventBus } from '@/util/eventBus';
import generalMix from '@/util/mix/general';
import resultcommons from '@/util/resultcommons';
import commons from '@/util/commons';
import * as types from '@/store/types';

export default {
  name: 'Sidebar',
  mixins: [generalMix],
  data () {
    return {
      // 阿里云域名头
      ossImgDomain: process.env.OSS_IMG_DOMAIN,
      // 导航
      navData: [],
    }
  },
  methods:{
    // 更新登录信息
    apiDealeruserlogininfo() {
      resultcommons.apiDealeruserlogininfo(this,{}).then(app=>{
        if(app.state === 200){
          // 更新本地缓存
          const localOb = this.localUser;
          localOb.isCredit = app.data.isCredit;
          localOb.isInvoice = app.data.isInvoice;
          commons.saveTodos('localUser', localOb);
          // 更新本地路由的登录信息
          this.$store.commit(types.SAVE_LOCALUSER, { bool: true });
          // 更新左侧导航
          EventBus.$emit('globalMakeSiderbarNavcate');
        }else{
          this.$message.showMsgBox({
            type: 'warning',
            content: '账号异常，请重新登陆'
          });
        }
      });
    },
    toLogin() {
      this.$router.push({ path: '/login' });
    },
    showWeicode() {
      EventBus.$emit('globalRightBoxFun', { type: 2, obj: { title:'联系微信' } });
    },
    // 导航
    globalMakeSiderbarNavcate() {
      if(this.localUser.isInvoice==='1'){
        this.navData = [
          {to:'/','class':'icon-shouye','title':'首页'},
          {to:'/product','class':'icon-daohang2','title':'产品仓库'},
          {to:'/group','class':'icon-baoguoxiangzi','title':'组合套装'},
          {to:'/collect','class':'icon-wenjuan','title':'快速清单'},
          {to:'/order','class':'icon-qinghuiyuan','title':'我的订单'},
          {to:'/invoice','class':'icon-wenjuan','title':'发票管理'},
          {to:'/advantage','class':'icon-wodeguanzhu','title':'个人信息'},
          {to:'/about','class':'icon-jinggao','title':'关于雪帝'}
        ];
      }else{
        this.navData = [
          {to:'/','class':'icon-shouye','title':'首页'},
          {to:'/product','class':'icon-daohang2','title':'产品仓库'},
          {to:'/group','class':'icon-baoguoxiangzi','title':'组合套装'},
          {to:'/collect','class':'icon-wenjuan','title':'快速清单'},
          {to:'/order','class':'icon-qinghuiyuan','title':'我的订单'},
          {to:'/advantage','class':'icon-wodeguanzhu','title':'个人信息'},
          {to:'/about','class':'icon-jinggao','title':'关于雪帝'}
        ];
      }
    }
  },
  mounted() {
    $('.dingBox').pin({
      containerSelector: '.pingBox',
      minWidth: 992
    })
    // 侧边栏
    const _this = this;
    const erd = elementResizeDetectorMaker();
    erd.listenTo($('#pingBox'), element => {
      _this.$nextTick(() => {
        //监听到事件后执行的业务逻辑
        $('.dingBox').pin({
          containerSelector: '.pingBox',
          minWidth: 992
        })
      });
    });
  },
  created() {
    // 更新登录信息
    Window.apiDealeruserlogininfo = setInterval(() => {
      this.apiDealeruserlogininfo();
    }, 2000);
    // 导航
    this.globalMakeSiderbarNavcate();
    // 方法
    EventBus.$on('globalMakeSiderbarNavcate', (ob) => {
      this.globalMakeSiderbarNavcate();
    });
  },
  destroyed() {
    clearInterval(Window.apiDealeruserlogininfo);
  }
}
</script>

<style scoped lang='less'>

  div.Sidebar{
    display: flex;
    flex-direction: column;
    width: 230px;
    .logBox{
      margin-top: 40px;
      img{
        height: 50px;
      }
    }
    .xiafangBox{
      flex: 1;
      display: flex;
      flex-direction: column;
      .userinfoBox{
        text-align: center;
        color: #FFFFFF;
        margin-top: 36px;
        //background: rgba(0,0,0,0.2);
        //backdrop-filter: saturate(180%) blur(20px);
        padding:25px;
        position: relative;
        margin-bottom: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: relative;
        overflow: hidden;
        .bgIcon{
          position: absolute;
          z-index: -1;
          font-size:210px;
          color: rgba(255,255,255,1);
          left: -80px;
          bottom: -110px;
        }
        div.headPortrait{
          width: 96px;
          height: 96px;
          border-radius: 50%;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          background-image: url("/static/images/touxiang.jpg");
        }
        img{
          width: 96px;
          height: 96px;
          border-radius: 50%;
        }
        h6{
          font-family: '微软雅黑';
          font-weight: bold;
          font-size: 16px;
          margin-top: 20px;
        }
        p{
          margin-bottom: 30px;
        }
        span{
          display: inline-block;
          background: #FFFFFF;
          padding: .8rem 1.25rem;
          border-radius: 50px;
          color: #333333;
          cursor: pointer;
          box-shadow: 0 0 1rem rgba(0,0,0,0.4) !important;
          &:hover{
            background: #ECECEC;
            transform: translateY(-3px);
          }
        }
      }
      .pingBox{
        flex: 1;
        //.dingBox
        .menuBox{
          grid-template-columns: 1fr 1fr;
          display: grid;
          grid-gap: 1.2rem;
          a{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 76px;
            cursor: pointer;
            i{
              font-size: 22px;
            }
            span{
              margin-top: 6px;
            }
            &:hover{
              background: #2A37FE;
              color: #FFFFFF;
            }
            &.active{
              background: #2A37FE;
              color: #FFFFFF;
            }
          }
        }
      }
    }
  }
  @media (max-width: 1200px) {
    div.Sidebar{
      width: 230px;
      .pingBox{
        .menuBox{
          a{
            height: 100px;
          }
        }
      }
    }
  }
  @media (max-width: 992px) {
    div.Sidebar{
      width:auto;
      .xiafangBox{
        flex-direction: row;
        margin-top: 30px;
        margin-bottom: 20px;
        .userinfoBox{
          margin: 0;
          width: 260px;
          background: rgba(0,0,0,0.2);
        }
        .pingBox{
          margin: 0;
          margin-left: 20px;
          .menuBox{
            height: 100%;
            background: rgba(0,0,0,0.1);
            background: #36353D;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
            border-radius: 5px;
            padding: 20px;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            a{
              height: 105px;
              i{
                margin: 0;
              }
            }
          }
        }
      }
    }
  }
  @media (max-width: 767px) {
    div.Sidebar{
      width:auto;
      .xiafangBox{
        margin-bottom: 0;
        flex-direction: column;
        .userinfoBox{
          margin-bottom: 20px;
          width: 100%;
        }
        .pingBox{
          margin: 0;
          .menuBox{
            grid-template-columns: 1fr 1fr 1fr 1fr;
            display: grid;
            grid-gap: 1rem;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            a{
              height: auto;
              padding: 10px 0;
              font-size: 12px;
              i{
                font-size: 22px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Sidebar.vue